<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Tesorería</li>
        <li class="breadcrumb-item active">Veificación de estado de cuenta </li>
      </ol>
    </nav>
    <div class="container-fluid" id="ba_main_table">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <vs-table stripe max-items="20" pagination search :data="suppliers" noDataText="No hay datos disponibles">
                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                            <h5 class="card-title">Proveedores con cuenta bancaria por verificar</h5>
                        </div>
                        

                        <template slot="thead">
                            <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].sid">
                                    <router-link :to="`/suppliers/${data[indextr].sid}`">
                                    {{ data[indextr].sid }}
                                    </router-link>
                                </vs-td>

                                <vs-td :data="data[indextr].uid">
                                    {{ data[indextr].uid }}
                                </vs-td>

                                <vs-td :data="data[indextr].name">
                                    {{ data[indextr].name }}
                                </vs-td>

                                <vs-td :data="data[indextr].tradename">
                                    {{ data[indextr].tradename }}
                                </vs-td>
                                <vs-td :data="data[indextr].verified_date">
                                    {{ data[indextr].verified_date | human_date}}
                                </vs-td>
                                <vs-td :data="data[indextr].file_verified_at">
                                    {{ data[indextr].file_verified_at | human_date }}
                                </vs-td>
                                <vs-td :data="data[indextr].TT">
                                    {{ data[indextr].TT }}
                                </vs-td>
                                <vs-td :data="data[indextr].TT">
                                    <div class="triage" :class="setTriageColor(data[indextr].TT)"></div>
                                </vs-td>
                                <vs-td :data="data[indextr].TT">
                                    <vs-button @click="openConfirm(data[indextr].bank_id, data[indextr])" color="warning" size="small" type="filled">Verificar</vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>
    </div>

    <!-- POPUP BANK ACCOUNTS -->
    <vs-popup v-if="supplier !== null" :title="popUpTitle" :active.sync="popUpActive" class="con-vs-popup extended-popup">
        <!-- PERSONAL INFORMATION PF -->
        <vx-card title="Información de proveedor" v-if=" supplier.person_type === 1 || supplier.person_type === 1" class="mb-4">
            <div class="vx-row">
                <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full">
                    <span>Nombre comercial: <span class="bold">{{supplier.tradename}}</span></span><br>
                    <span>Nombre: <span class="bold">{{supplier.name}}</span></span> <br>
                </div>
                <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-full">
                    <span v-if="supplier.person_type === 1">CURP: <span class="bold">{{supplier.curp}}</span></span><br>
                    <span v-if="get_rfc_tin(supplier)">RFC: <span class="bold">{{supplier.rfc}}</span></span>
                    <span v-else>TIN: <span class="bold">{{supplier.tin}}</span></span>
                </div>
            </div>
        </vx-card>

        <!-- IDENTITY DOCUMENTS -->
        <vx-card title="Documentos de identidad" class="mb-4">
            <div class="vx-row">
                <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-full">
                    <p>ID oficial frente</p>
                    <embed :src="StorageURL + id_front.url_file" width="600" height="300" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" v-if="isPDF(id_front.filename)">
                    <div class="file" v-else>
                        <img alt="id_oficial_frente" :src="StorageURL + id_front.url_file" style="max-width: 20rem; max-height: 20rem;">
                    </div>
                </div>
                <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-full">
                    <p>ID oficial posterior</p>
                    <embed :src="StorageURL + id_back.url_file" width="600" height="300" alt="pdf" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" v-if="isPDF(id_back.filename)">
                    <div class="file" v-else>
                        <img alt="id_oficial_frente" :src="StorageURL + id_back.url_file" style="max-width: 20rem; max-height: 20rem;">
                    </div>

                </div>
            </div>
        </vx-card>

        <!-- BANK ACCOUNTS -->
        <vx-card style="padding: 0px;" class="mb-4">
            <h3>Cuentas bancarias</h3>
            <div v-if="formattedAccounts.length != 0" class="col-md-12">
                <vs-table stripe max-items="20" pagination :data="formattedAccounts" noDataText="No hay datos disponibles">
                    <template slot="thead">
                        <vs-th class="bold" v-for="(col, idx) in columnsBankAccounts" v-bind:key="idx" :sort-key="col.sortable ? col.key : null" >{{col.title}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :state="isAccountSelected(tr) ? 'black' : null">
                            <vs-td :data="data[indextr].bank_name">
                                {{ data[indextr].bank_name }}
                            </vs-td>

                            <vs-td :data="data[indextr].clabe">
                                {{ data[indextr].clabe || data[indextr].bic_swift }}
                            </vs-td>
                        
                            <vs-td :data="data[indextr].status_name">
                                {{ data[indextr].status_name }}
                            </vs-td>

                            <vs-td :data="data[indextr].name">
                                <div
                                    class="flex items-center flex-grow flex-no-wrap w-full"
                                    >
                                    <feather-icon
                                        icon="StarIcon"
                                        :svgClasses="getSelectIconClass(tr)"
                                    />
                                    <feather-icon
                                        v-if="!tr.is_verified"
                                        icon="CheckSquareIcon"
                                        :svgClasses="klassFull"
                                        class="ml-5"
                                        @click.stop="verifiedRequestAction(tr)"
                                    />
                                </div>
                            </vs-td>

                     
                            <template class="expand-user" slot="expand">
                                <div class="vx-row">
                                    <div :class="tr.is_verified ? 'vx-col lg:w-1/2 md:w-1/2 sm:w-full' : 'vx-col sm:w-full'">
                                        <document-upload-lite
                                            name="Caratula Estado de Cuenta"
                                            :check-url="checkUrl(tr)"
                                            :view-url="viewUrl(tr)"
                                            :download-url="downloadUrl(tr)"
                                            upload-url="/"
                                            width="1"
                                            class="pt-2 pb-2 pr-2 pl-2"
                                            :canUpload="false"
                                            :selfAccessToken="_selfAccessToken"
                                        />
                                    </div>
                                    <div v-if="tr.is_verified" class="vx-col lg:w-1/2 md:w-1/2 sm:w-full">
                                        <vx-card>
                                            <h5>Información adicional</h5>
                                            <ul>
                                                <li>
                                                    F. Verificación: {{tr.verified_date | human_date}}
                                                </li>
                                                <li>
                                                    Verificado por: {{tr.verified_by}}
                                                </li>
                                            </ul>
                                        </vx-card>
                                    </div>
                                </div>
                            </template>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vx-card>

        <!-- CRITERIA -->
        <vs-row v-if="supplier != null" vs-justify="center" style="margin-top:10px;">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div>
                    <vs-list>
                        <vs-list-header icon="how_to_reg" title="Criterios de verificación" color="success"/>
                        <vs-list-item icon="check" title="El estado de cuenta no debe ser mayor a 6 meses." />
                        <vs-list-item icon="check" title="El nombre de la identificación debe  corresponder con el estado de cuenta." />
                        <vs-list-item icon="check" title="La CLABE del estado de cuenta debe corresponder con el registrado." />
                    </vs-list>
                </div>
            </vs-card>
            </vs-col>
        </vs-row>

        <!-- NOTES -->

        <vs-row v-if="supplier != null" vs-justify="center" style="margin-top:10px;">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-card>
            <div slot="header"><h5>Notificación a proveedor</h5></div>
            <vs-textarea label="Escribe los comentarios..." v-model="reasons" />
            <vs-button :disabled="reasons == ''" color="warning" type="filled" icon="send" style="float: right; margin-bottom: 20px" @click="requestEmail();">Enviar Correo</vs-button>
            <vs-divider color="warning" style="margin-top: 10px"/>
            <vs-table noDataText="">
              <vs-tr v-for="message in messages" v-bind:key="message.id">
                <vs-td style="width: 10%;">
                  <vs-chip color="primary" style="width: 100%;">
                    <vs-icon icon="schedule" color="white" style="margin-right: 10%; margin-left: -10%"/>
                    {{message.created_at|human_date}}
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <vs-chip color="orange">
                    <vs-icon icon="person" color="white"/>
                    {{message.email}}
                  </vs-chip><br><br>
                  <div class="note-pad">{{message.note}}</div>
                </vs-td>
              </vs-tr>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>

        <vs-popup title="Enviar correo" :active.sync="popupActivo3">
            <p>
            {{emailBody}}
            <br><br>
            <strong>{{reasons}}</strong>
            </p>
            <br><br>
            <vs-button @click="sendEmail()" color="primary" type="filled">Envíar notificación</vs-button>
        </vs-popup>
    </vs-popup>
  </div>
</template>

<script lang="js">
import * as moment from 'moment'
import { mapState } from 'vuex';
import swal from "sweetalert";
import {AxiosErrorException} from "../functions/axiosErrorException";
import DocumentUploadLite from "@components/misc/DocumentUploadLite";
import {BankAccountStatus} from "@/models/BankAccountStatus";

const itemsPerPageDefinitions = [5,10,25,50];
const pfae_document_ids = [2, 3];
const pm_document_ids = [12, 13];

const emailBody = "Tuvimos problemas para verificar tu cuenta de banco, por favor atiende los siguientes comentarios.";

const columnDefinitions = [
  { title: "SID", key: "sid", sortable: true },
  { title: "UID", key: "uid", sortable: true },
  { title: "NOMBRE/RAZÓN SOCIAL", key: "nombre", sortable: true },
  { title: "NOMBRE COMERCIAL", key: "comercial", sortable: true },
  { title: "PROVEEDOR DESDE", key: "verified_date", sortable: true },
  { title: "F. VERIFICACIÓN DE ESTADO DE CUENTA", key: "file_verified_at", sortable: true },
  { title: "TT (DÍAS)", key: "TT", sortable: true },
  { title: "SEMÁFORO", key: "triage", sortable: false },
  { title: "ACCIONES", key: "actions", sortable: false },
];

const columnsBankAccounts = [
    { title: "BANCO", key: "BANK", sortable: true },
    { title: "CLABE/BIC/SWIFT", key: "CLABE", sortable: true },
    { title: "ESTATUS", key: "STATUS", sortable: true },
    { title: "ACCIONES", key: "verification_date", sortable: false },
];

export default {
    name: 'suppliers_not_verified',
    filters: {
        human_date(date) {
            if(date != null && date != '0000-00-00 00:00:00'){
                return moment(date).lang("es").format("D MMM YYYY");
            } else {
                return '-'
            }
          }
    },
    components: {
        DocumentUploadLite
    },
    props: [],
    data() {
      return {
        data: [],
        search: '',
        suppliers: [],
        buscando: false,
        slas: {},
        itemsPerPageDefinitions: itemsPerPageDefinitions,
        itemsPerPage: itemsPerPageDefinitions[0],
        columns: columnDefinitions,
        current_ba_id: null,

        // VERIFICACIÓN DE CUENTAS BANCARIAS
        popUpActive: false,
        popupActivo3: false,
        popUpTitle: "Verificación de cuenta",
        supplier: null,
        pfae_document_ids: pfae_document_ids,
        pm_document_ids: pm_document_ids,
        id_front: "", 
        id_back: "",
        columnsBankAccounts: columnsBankAccounts,
        userAccounts: [],
        formattedAccounts: [],
        collections: {
            banks: [],
        },
        accountIdSelected: null,
        mexicoCountryId: 700,
        klassFull: "h-5 w-5 stroke-current hover:text-primary cursor-pointer",
        accountToVerify: null,
        reasons: '',
        messages: [],
        emailBody: emailBody

      }
    },
    async created() {
        this.showLoading(true);
        const {data} = await axios.get('/api/sla_df_verification');
        this.slas = data;
        await this.getSuppliersNotVerified();
        await this.getCollections();
        this.showLoading(false);
    },
    methods: {
        async openConfirm(ba_id, supplier){
            this.showLoading(true);
            this.popUpTitle = "Verificación de cuenta.";
            this.reasons = '';
            this.current_ba_id = ba_id;
            this.supplier = supplier;
            this.getClientDocuments();
            await this.getUserAccounts();
            this.setDefaults();
            this.getNotes();
            this.popUpTitle= `Verificación de cuenta - SID: ${this.supplier.sid} | ${this.supplier.name}.`;
            this.popUpActive = true;
            this.showLoading(false);
        },
        getSuppliersNotVerified(){
            axios.get( '/api/suppliers/bankAccounts/notVerified')
            .then(response => {
                this.suppliers = response.data.suppliers;
            });
        },
        searchSupplier() {
            if(this.search != ''){
                if(this.buscando == false){
                    this.buscando=true;
                    axios.post( '/api/suppliers/notVerified/search', {
                        status: status,
                        search: this.search,
                    })
                    .then(response => {
                    this.suppliers = response.data.suppliers;
                    this.buscando = false;
                    });
                }
            } else {
                this.getSuppliersNotVerified();
            }
        },
        getStatus($status){
            switch ($status) {
            case 1:
                return 'Instaladores no activados';
                break;
            case 2:
                return 'Instaladores activados, no verificados';
                break;
            case 3:
                return 'Instaladores en proceso de verificación';
                break;
            case 4:
                return 'Verificados, sin proyecto fondeado o sin solicitudes';
                break;
            case 5:
                return 'Con proyecto fondeado, más de 3 meses sin solicitud';
                break;
            case 6:
                return 'Con proyecto fondeado, más de 1 mes sin solicitud y menos o igual a 3 meses';
                break;
            case 7:
                return 'Con proyecto fondeado o sin solicitud por un mes o menos';
                break;
            default:
                return 'Indefinido';
                break;
            }
        },
        setTriageColor(TT) {
            
            let redValue = parseInt(this.slas.sla_verified[3].val);
            let yellowValue = parseInt(this.slas.sla_verified[4].val);
            try {
                if(TT > redValue ){
                  return 'triage-red';
                } else if(TT > yellowValue){
                    return 'triage-yellow';
                } else {
                    return 'triage-green';
                }
            } catch(err) {
                return '';
            }
        },
        get_rfc_tin(supplier){
            if(supplier.person_type === 2 || supplier.person_type === 3){
                return 2;
            } else {
                return 1;
            }
        },
        async getClientDocuments(){
            this.id_front = '';  
            this.id_back = '';
            this.accountfile = '';
            let ids = [];

            if(this.supplier.person_type === 1 || this.supplier.person_type === 2){
                ids = this.pfae_document_ids;
            } else {
                ids = this.pm_document_ids;
            }


            this.id_front = await this.getFile(this.supplier.uid, ids[0]);
            this.id_back = await this.getFile(this.supplier.uid, ids[1]);
        },
        async getFile(user_id, document_id){
            try{
                let url_data = `/storagev3/documents/files/${document_id}/user/${user_id}`
                let response = await axios.get(url_data);
                if(response.data.length > 0){
                    let file = response.data[0];
                    return {
                    url_file: `/storagev3/documents/view_document_file/${file.id}/user/${user_id}?access_token=${this.user.access_token}`,
                    filename: file.storage_file
                    }
                }else{
                    return '';
                }
            }catch(e){
                return '';
            }
        },
        isPDF(filename){
            if(filename != null){
                let data = filename.split('.')
                let ext = data[data.length-1]
                return (ext.toLowerCase() == 'pdf');
            }
        },
        async getUserAccounts() {
            try {
                const res = await axios.get(`api/backoffice/bank-account/${this.supplier.uid}`);
                const accs = res.data;
                this.userAccounts = accs;
                this.formattedAccounts = [];
                accs.forEach((f) => {
                let nacc = this.getFormattedAccount(f);
                this.formattedAccounts.push(nacc);
                });

                this.formattedAccounts.sort(function (a, b) {
                if (a.is_default) {
                    return -1;
                } else if (b.is_default) {
                    return 1;
                } else if (a.is_verified && b.is_verified) {
                    return a.clabe > b.clabe;
                } else if (a.is_verified && !b.is_verified) {
                    return -1;
                } else if (!a.is_verified && b.is_verified) {
                    return 1;
                }
                return 0;
                });
            } catch (e) {}
        },
        async getCollections() {
            try {
                let collectionsObjects = [
                "banksForMexico",
                ];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                let colls = res.data;
                this.collections.banks = colls.banksForMexico;
            } catch (e) {
                this.warn(e);
                this.failed = true;
            }
        },
        getSelectIconClass(tr) {
            let klass = this.klassBase;
            if (this.isAccountSelected(tr)) {
                klass += " fill-current";
            } else {
                if (this.isSelectable(tr)) {
                klass += " hover:text-primary cursor-pointer";
                } else {
                klass += " opacity-30";
                }
            }
            return klass;
        },
        isAccountSelected(tr) {
            return tr.id === this.accountIdSelected;
        },
        isSelectable(tr) {
            return tr.is_verified;
        },
        isVerified(tr) {
            return tr.is_verified;
        },
        setDefaults() {
            let account = this.formattedAccounts.find((f) => f.is_default);
            if (account != null) {
                this.accountIdSelected = account.id;
            }
        },
        getFormattedAccount(f) {
            let nacc = {
                id: f.id,
                bank_id: f.bank_id,
                is_default: f.is_default === 1,
                is_verified: f.verified === BankAccountStatus.VERIFIED,
                status_name: BankAccountStatus.getAccountStatusName(f.verified),
                document_file_id: f.document_file_id,
                verified_date: f.verified_date,
                verified_by: f.verified_by

            };

            if (f.bank && f.bank.country_id === this.mexicoCountryId) {
                nacc.bank_name = f.bank.short_name;
                nacc.clabe = f.clabe;
            } else {
                nacc.bank_name = f.bank.name;
                nacc.clabe = f.bic_swift;
            }
            return nacc;
        },
        verifiedRequestAction(account){
            this.accountToVerify = account;
            if(account != null){
                this.$vs.dialog({
                    color: "warning",
                    type: "confirm",
                    title: "Verificación de cuenta bancaría",
                    text:`Está seguro de verificar la cuenta bancaria con CLABE <<${account.clabe}>> del SID: <<${this.supplier.sid} - ${this.supplier.name}>>?`,
                    acceptText: "Verificar",
                    cancelText: "Cancelar",
                    accept: this.doVerifyAccount,
                });
                
            } else {
                this.errorNotif("No hay cuenta por verififcar", "Algo ha salido mal y no se selccionó la cuenta para su verificación.");
            }
        },
        async doVerifyAccount(){
            this.showLoading(true);
            if(this.accountToVerify !== null) {
                try {
                    const res = await axios.get( '/api/users/'+this.supplier.uid+'/verify/'+this.accountToVerify.id);
                    await this.getUserAccounts();
                    this.setDefaults();
                } catch (e) {
                    this.warn(e);
                } 
            }
            this.showLoading(false);
        },
        checkUrl(cuenta){
            if(cuenta.document_file_id != null){
                return `files/getDocumentFile/${cuenta.document_file_id}`;
            }
            return "";
        },
        viewUrl(cuenta){
            if(cuenta.document_file_id != null){
                return `view_document_file/${cuenta.document_file_id}/user/${this.supplier.uid}`;
            }
            return "";
        },
        downloadUrl(cuenta){
            if(cuenta.document_file_id != null){
                return `download_document_file/${cuenta.document_file_id}/user/${this.supplier.uid}`;
            }
            return "";
        },
        getNotes(){
            if(this.supplier != null){
                this.messages = []
                axios.post( '/api/clients-control/notes/get',{
                    sid: this.supplier.sid
                }).then((resolve) => {
                    this.messages = resolve.data.notes;
                });
            }
        },
        requestEmail(){
            this.popupActivo3 = true;
        },
        async sendEmail(){
            this.showLoading(true);
            this.$vs.notify({title:'Enviando correo...',text:'Espere un momento',color:'dark',position:'bottom-center',icon:'access_time'})
            const payload = {
                reasons: this.reasons,
                nombre: this.supplier.name,
                email: this.supplier.email,
                sid: this.supplier.sid,
                from: 'banco'
            };

            axios.post( '/api/clients-control/send/correo', payload).then((resolve) => {
                    this.$vs.notify({title:'¡Listo!',text:'Correo enviado correctamente',color:'success',position:'bottom-center',icon:'done'})
                    this.reasons = ''
                    this.popupActivo3 = false;
                    this.getNotes()
                    this.showLoading(false);
            }).catch(error => {
                this.$vs.notify({title:'¡ERROR!',text:'Algo salió mal...',color:'danger',position:'bottom-center',icon:'error'})
            });
            this.showLoading(false);
        },
    },
    computed: {
        _selfAccessToken: function(){
            return this.user.access_token;
        }
    }
}
</script>
<style scoped>
  .triage {
      width: 1.5rem;
      height: 1.5rem;
      background-color: #ccc;
      margin-left: 1.5rem;
      border-radius: 5pc;
      -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
  }

  .triage-red {
    background-color: red !important;
  }
  .triage-yellow {
    background-color: yellow !important;
  }
  .triage-green {
    background-color: green !important;
  }

  .con-vs-dialog .vs-dialog {
      z-index: 90000 !important;
  }
  .con-vs-popup {
    z-index: 15864 !important;
    }

 embed {
    height: 300px !important;
  }
</style>